export const iosLink = 'https://apps.apple.com/us/app/nearo/id1521128681';
export const androidLink = 'https://play.google.com/store/apps/details?id=app.nearo.android';